<template>
  <div class="d-flex justify-content-center py-3 position-relative">
    <div class="align-self-center box-shadow text-center border-upload-image d-flex">
      <div class="d-flex flex-column align-items-center justify-content-center">
        <img class="img-thumbnail" :src="userAvatar" />
      </div>
      <div class="image-upload-wrap" :class="!isCurrentUser ? 'pt-4' : ''" v-if="!userAvatar">
        <b-form-file
          v-if="isCurrentUser && !userAvatar"
          id="user-profile-uploader"
          :state="Boolean(userAvatar)"
          :placeholder="trans('profile.load_avatar')"
          drop-placeholder="Drop file here"
          accept="image/jpeg, image/png, image/bmp"
          class="file-upload-input"
          @change="$emit('onUploadImage', $event)"
        ></b-form-file>
        <h1 class="display-1 title text-center py-4 mt-0 mb-2 v-if=" v-if="!userAvatar">
          {{ userInfo ? userInfo.initials : "" }}
        </h1>
      </div>
    </div>
    <div v-if="isCurrentUser && userAvatar" class="delete-icon-wrapper">
      <span class="delete-icon d-flex justify-content-center" @click="$emit('onDeleteImage')">
        <i class="fa fa-trash text-white" />
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: "ProfilePhoto",
  props: {
    userAvatar: String | null,
    userInfo: Object,
    onUploadImage: Function,
    onDeleteImage: Function,
    validatorSuccess: String,
    validatorFails: String,
    isCurrentUser: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.title {
  color: $color-dark-600;
}
.image-upload-wrap {
  width: 100%;
}
.img-thumbnail {
  border: none;
  padding: 0;
}
.delete-icon-wrapper {
  position: absolute;
  bottom: 20px;
  padding-left: 100px;
}
.delete-icon {
  cursor: pointer;
  width: 32px;
  height: 32px;
  background: $color-orange;
  border-radius: 100%;

  i {
    line-height: 30px;
  }
}

::v-deep .custom-file-label {
  padding: 2rem 1rem;
}

::v-deep .custom-file-input.is-invalid ~ .custom-file-label {
  height: 200px;
  background: none;
  border: none;

  &:hover {
    cursor: pointer;
  }
}

::v-deep .custom-file-input ~ .custom-file-label[data-browse]::after {
  visibility: hidden !important;
}

.border-upload-image {
  border: 4px solid $color-orange;
  border-radius: 100%;
  width: 200px;
  height: 200px;
  overflow: hidden;
}
</style>
